/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AgreementService } from './services/AgreementService';
import { BatchService } from './services/BatchService';
import { BrowsingHistoryService } from './services/BrowsingHistoryService';
import { CommonService } from './services/CommonService';
import { MedicalInstitutionService } from './services/MedicalInstitutionService';
import { OfficialAnnouncementService } from './services/OfficialAnnouncementService';
import { OrganizationService } from './services/OrganizationService';
import { OrganizationActivityLogService } from './services/OrganizationActivityLogService';
import { PartnershipService } from './services/PartnershipService';
import { PortalAgreementService } from './services/PortalAgreementService';
import { PortalOfficeService } from './services/PortalOfficeService';
import { PortalOfficeActivityLogService } from './services/PortalOfficeActivityLogService';
import { PortalOfficeHospitalListingService } from './services/PortalOfficeHospitalListingService';
import { PortalOfficeListingService } from './services/PortalOfficeListingService';
import { PortalOfficeListingAllTypeService } from './services/PortalOfficeListingAllTypeService';
import { PortalOfficeScheduleService } from './services/PortalOfficeScheduleService';
import { PortalPatientService } from './services/PortalPatientService';
import { PortalStaffService } from './services/PortalStaffService';
import { PortalStaffInvitationService } from './services/PortalStaffInvitationService';
import { PortalStaffNotificationService } from './services/PortalStaffNotificationService';
import { PortalStaffNotificationLogService } from './services/PortalStaffNotificationLogService';
import { RequestCardService } from './services/RequestCardService';
import { RequestUserService } from './services/RequestUserService';
import { RequestUserFavoriteService } from './services/RequestUserFavoriteService';
import { RequestUserInvitationService } from './services/RequestUserInvitationService';
import { RequestUserNotificationService } from './services/RequestUserNotificationService';
import { RequestUserNotificationLogService } from './services/RequestUserNotificationLogService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class SwaggerClient {
    public readonly agreement: AgreementService;
    public readonly batch: BatchService;
    public readonly browsingHistory: BrowsingHistoryService;
    public readonly common: CommonService;
    public readonly medicalInstitution: MedicalInstitutionService;
    public readonly officialAnnouncement: OfficialAnnouncementService;
    public readonly organization: OrganizationService;
    public readonly organizationActivityLog: OrganizationActivityLogService;
    public readonly partnership: PartnershipService;
    public readonly portalAgreement: PortalAgreementService;
    public readonly portalOffice: PortalOfficeService;
    public readonly portalOfficeActivityLog: PortalOfficeActivityLogService;
    public readonly portalOfficeHospitalListing: PortalOfficeHospitalListingService;
    public readonly portalOfficeListing: PortalOfficeListingService;
    public readonly portalOfficeListingAllType: PortalOfficeListingAllTypeService;
    public readonly portalOfficeSchedule: PortalOfficeScheduleService;
    public readonly portalPatient: PortalPatientService;
    public readonly portalStaff: PortalStaffService;
    public readonly portalStaffInvitation: PortalStaffInvitationService;
    public readonly portalStaffNotification: PortalStaffNotificationService;
    public readonly portalStaffNotificationLog: PortalStaffNotificationLogService;
    public readonly requestCard: RequestCardService;
    public readonly requestUser: RequestUserService;
    public readonly requestUserFavorite: RequestUserFavoriteService;
    public readonly requestUserInvitation: RequestUserInvitationService;
    public readonly requestUserNotification: RequestUserNotificationService;
    public readonly requestUserNotificationLog: RequestUserNotificationLogService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '/api',
            VERSION: config?.VERSION ?? '1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.agreement = new AgreementService(this.request);
        this.batch = new BatchService(this.request);
        this.browsingHistory = new BrowsingHistoryService(this.request);
        this.common = new CommonService(this.request);
        this.medicalInstitution = new MedicalInstitutionService(this.request);
        this.officialAnnouncement = new OfficialAnnouncementService(this.request);
        this.organization = new OrganizationService(this.request);
        this.organizationActivityLog = new OrganizationActivityLogService(this.request);
        this.partnership = new PartnershipService(this.request);
        this.portalAgreement = new PortalAgreementService(this.request);
        this.portalOffice = new PortalOfficeService(this.request);
        this.portalOfficeActivityLog = new PortalOfficeActivityLogService(this.request);
        this.portalOfficeHospitalListing = new PortalOfficeHospitalListingService(this.request);
        this.portalOfficeListing = new PortalOfficeListingService(this.request);
        this.portalOfficeListingAllType = new PortalOfficeListingAllTypeService(this.request);
        this.portalOfficeSchedule = new PortalOfficeScheduleService(this.request);
        this.portalPatient = new PortalPatientService(this.request);
        this.portalStaff = new PortalStaffService(this.request);
        this.portalStaffInvitation = new PortalStaffInvitationService(this.request);
        this.portalStaffNotification = new PortalStaffNotificationService(this.request);
        this.portalStaffNotificationLog = new PortalStaffNotificationLogService(this.request);
        this.requestCard = new RequestCardService(this.request);
        this.requestUser = new RequestUserService(this.request);
        this.requestUserFavorite = new RequestUserFavoriteService(this.request);
        this.requestUserInvitation = new RequestUserInvitationService(this.request);
        this.requestUserNotification = new RequestUserNotificationService(this.request);
        this.requestUserNotificationLog = new RequestUserNotificationLogService(this.request);
    }
}

